import { string, func, oneOfType, bool } from 'prop-types';

import PageRow from 'components/PageRow';
import leftArrow from 'assets/ic_back.png';
import info from 'assets/info.png';
import useGlobalState from 'actions';
import LoanDetailsDialog from 'components/dialogs/LoanDetailsDialog';
import services from 'services';

import * as Trackers from 'pages/LoanServicing/PaymentHistory/trackers';

const SubHeader = ({ onBackClick, padding, title, isInfo, size, loanXid }) => {
  const [globalState, globalActions] = useGlobalState();

  const openLoanInfo = () => {
    Trackers.clickInformation();
    const payload = {
      loan_xid: loanXid,
    };
    services.loan.getLoanDetail(
      payload,
      (response) => {
        if (response.data) {
          localStorage.setItem('selected_status', response.data.status);
          localStorage.setItem(
            'selected_daily_repayment',
            globalActions.thousands_separators(response.data.daily_repayment),
          );
          localStorage.setItem('selected_start_pay', response.data.start_pay);
          localStorage.setItem(
            'selected_disbursed',
            globalActions.thousands_separators(response.data.disbursed),
          );
          localStorage.setItem(
            'selected_remaining_payment',
            globalActions.thousands_separators(response.data.remaining_payment),
          );
          localStorage.setItem(
            'selected_successful_payment',
            globalActions.thousands_separators(
              response.data.successful_payment,
            ),
          );

          globalActions.openLoanDetailsDialog('preOpen', true);
        } else {
          globalActions.openLoanDetailsDialog('preOpen', false);
        }
      },
      () => {
        globalActions.openLoanDetailsDialog('preOpen', false);
      },
    );
  };

  return (
    <PageRow padding={padding} size={size}>
      <div
        style={{
          float: 'left',
          width: '100%',
          backgroundImage: 'linear-gradient(to right, #00acf0 8%, #13637b)',
        }}
      >
        {onBackClick ? (
          <div
            style={{
              float: 'left',
              paddingTop: '16px',
              paddingLeft: '16px',
              paddingRight: '5px',
              marginTop: 35,
            }}
          >
            <img
              src={leftArrow}
              alt='back'
              className='img'
              onClick={onBackClick ? onBackClick : null}
              style={{ marginRight: 10 }}
              data-testid='btnBackNav'
            />
          </div>
        ) : null}
        {onBackClick ? (
          <div style={{ float: 'left', marginTop: 45, paddingTop: '13px' }}>
            <span className='subHeaderTitle'>{title}</span>
          </div>
        ) : (
          <div
            style={{
              float: 'left',
              paddingTop: '15px',
              paddingLeft: '16px',
              paddingBottom: '15px',
            }}
          >
            <span className='subHeaderTitle'>{title}</span>
          </div>
        )}

        {isInfo ? (
          <div
            style={{
              float: 'right',
              marginTop: 45,
              paddingTop: '13px',
              paddingRight: '10px',
            }}
          >
            <img
              src={info}
              alt='info'
              style={{ cursor: 'pointer' }}
              onClick={openLoanInfo}
            />
            <LoanDetailsDialog
              preOpen={globalState.preOpen}
              loanXid={loanXid}
            />
          </div>
        ) : null}
      </div>
    </PageRow>
  );
};

SubHeader.propTypes = {
  onBackClick: func,
  title: string,
  isInfo: bool,
  padding: oneOfType([string, bool]),
  size: oneOfType([string, bool]),
  loanXid: string,
};

SubHeader.defaultProps = {
  onBackClick: () => {},
  title: '',
  isInfo: false,
  padding: null,
  size: null,
  loanXid: null,
};

export default SubHeader;
